export default __webpack_public_path__ + "static/media/9.b9a779f0.jpg";